export const GEO_CODE_TO_DISPLAY_MAP = {
  US: 'United States',
  FI: 'Finland',
  CA: 'Canada',
  GB: 'United Kingdom',
  DE: 'Germany',
  MX: 'Mexico',
  AU: 'Australia',
  FR: 'France',
  ES: 'Spain',
  NL: 'Netherlands',
  IN: 'India',
  CN: 'China',
  IE: 'Ireland',
  IT: 'Italy',
  SG: 'Singapore',
  RU: 'Russia',
  SE: 'Sweden',
  PL: 'Poland',
  BE: 'Belgium',
  GR: 'Greece',
  IL: 'Israel',
  BR: 'Brazil',
  TR: 'Turkey',
  PH: 'Philippines',
  HR: 'Croatia',
  RO: 'Romania',
  NZ: 'New Zealand',
  CH: 'Switzerland',
  BY: 'Belarus',
  AE: 'United Arab Emirates',
  PT: 'Portugal',
  NO: 'Norway',
  DK: 'Denmark',
  CO: 'Colombia',
  PR: 'Puerto Rico',
  SA: 'Saudi Arabia',
  AT: 'Austria',
  JP: 'Japan',
  MY: 'Malaysia',
  CZ: 'Czech Republic',
  PK: 'Pakistan',
  HK: 'Hong Kong',
  SK: 'Slovakia',
  AR: 'Argentina',
  CL: 'Chile',
  DO: 'Dominican Republic',
  ID: 'Indonesia',
  UA: 'Ukraine',
  BG: 'Bulgaria',
  PE: 'Peru',
  ZA: 'South Africa',
  TH: 'Thailand',
  HU: 'Hungary',
  VN: 'Vietnam',
  PA: 'Panama',
  KR: 'South Korea',
  RS: 'Serbia',
  TN: 'Tunisia',
  EC: 'Ecuador',
  NG: 'Nigeria',
  SI: 'Slovenia',
  BD: 'Bangladesh',
  TT: 'Trinidad and Tobago',
  TW: 'Taiwan',
  EG: 'Egypt',
  VE: 'Venezuela',
  CR: 'Costa Rica',
  KW: 'Kuwait',
  MA: 'Morocco',
  EE: 'Estonia',
  JO: 'Jordan',
  KE: 'Kenya',
  CY: 'Cyprus',
  LT: 'Lithuania',
  HN: 'Honduras',
  SV: 'El Salvador',
  JM: 'Jamaica',
  LU: 'Luxembourg',
  IQ: 'Iraq',
  GT: 'Guatemala',
  QA: 'Qatar',
  LV: 'Latvia',
  MK: 'North Macedonia',
  NP: 'Nepal',
  KZ: 'Kazakhstan',
  DZ: 'Algeria',
  GH: 'Ghana',
  LB: 'Lebanon',
  AL: 'Albania',
  IS: 'Iceland',
  GE: 'Georgia',
  BA: 'Bosnia and Herzegovina',
  CW: 'Curaçao',
  AZ: 'Azerbaijan',
  LK: 'Sri Lanka',
  AM: 'Armenia',
  MT: 'Malta',
  AW: 'Aruba',
  BS: 'Bahamas',
  LC: 'Saint Lucia',
  NI: 'Nicaragua',
  PS: 'Palestine',
  MN: 'Mongolia',
  PY: 'Paraguay',
  BH: 'Bahrain',
  BB: 'Barbados',
  KG: 'Kyrgyzstan',
  TC: 'Turks and Caicos Islands',
  OM: 'Oman',
  AG: 'Antigua and Barbuda',
  GU: 'Guam',
  BO: 'Bolivia',
  ZM: 'Zambia',
  RW: 'Rwanda',
  CU: 'Cuba',
  MU: 'Mauritius',
  KH: 'Cambodia',
  GY: 'Guyana',
  UZ: 'Uzbekistan',
  MD: 'Moldova',
  ZW: 'Zimbabwe',
  BM: 'Bermuda',
  LA: 'Laos',
  SX: 'Sint Maarten',
  SC: 'Seychelles',
  MM: 'Myanmar',
  ME: 'Montenegro',
  SN: 'Senegal',
  UY: 'Uruguay',
  MV: 'Maldives',
  LY: 'Libya',
  BN: 'Brunei',
  BZ: 'Belize',
  KY: 'Cayman Islands',
  MP: 'Northern Mariana Islands',
  TZ: 'Tanzania',
  RE: 'Réunion',
  XK: 'Kosovo',
  BQ: 'Bonaire, Sint Eustatius, and Saba',
  GP: 'Guadeloupe',
  SL: 'Sierra Leone',
  AO: 'Angola',
  BW: 'Botswana',
  MG: 'Madagascar',
  MZ: 'Mozambique',
  GM: 'Gambia',
  GI: 'Gibraltar',
  TJ: 'Tajikistan',
  IM: 'Isle of Man',
  MO: 'Macau',
  VI: 'U.S. Virgin Islands',
  VC: 'Saint Vincent and the Grenadines',
  GG: 'Guernsey',
  LI: 'Liechtenstein',
  UG: 'Uganda',
  KN: 'Saint Kitts and Nevis',
  LR: 'Liberia',
  NA: 'Namibia',
  SO: 'Somalia',
  DM: 'Dominica',
  FO: 'Faroe Islands',
  CD: 'Democratic Republic of the Congo',
  FJ: 'Fiji',
  BI: 'Burundi',
  MW: 'Malawi',
  CI: "Côte d'Ivoire",
  CM: 'Cameroon',
  TL: 'Timor-Leste',
  PM: 'Saint Pierre and Miquelon',
  GD: 'Grenada',
  ET: 'Ethiopia',
  AF: 'Afghanistan',
  DJ: 'Djibouti',
  VG: 'British Virgin Islands',
  SR: 'Suriname',
  CV: 'Cape Verde',
  GN: 'Guinea',
  AD: 'Andorra',
  MC: 'Monaco',
  AX: 'Åland Islands',
  JE: 'Jersey',
  HT: 'Haiti',
  PF: 'French Polynesia',
  GQ: 'Equatorial Guinea',
  BJ: 'Benin',
  IR: 'Iran',
  TG: 'Togo',
  GF: 'French Guiana',
  LS: 'Lesotho',
  NC: 'New Caledonia',
  MR: 'Mauritania',
  SY: 'Syria',
  MQ: 'Martinique',
  NE: 'Niger'
};

export const isValidCountryCode = code => GEO_CODE_TO_DISPLAY_MAP[code] !== undefined;

export const formatCityCountryFromLocation = location => {
  if (location.city) {
    return `${location.city}, ${location.country}`;
  }
  return GEO_CODE_TO_DISPLAY_MAP[location.country] || location.country;
};
